(function() {
  function clearInfluencer() {
    try {
      localStorage.removeItem('influencer');
    } catch(e) {
      console.warn('Could not clear influencer', e);
    }
    var url = new URL(window.location.href);
    url.searchParams.delete('influencer');
    history.replaceState({}, '', url.toString());
  }

  function persistInfluencerInUrl(code) {
    if (!code) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get('influencer') !== code) {
      url.searchParams.set('influencer', code);
      history.replaceState({}, '', url.toString());
    }
  }

  function setInfluencer() {
    // Case: if URL has "thank_you" -> clear immediately
    if (window.location.href.includes('thank_you')) {
      clearInfluencer();
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var influencer = params.get('influencer');

    if (influencer) {
      influencer = decodeURIComponent(influencer);
      try {
        localStorage.setItem('influencer', influencer);
      } catch(e) {
        console.warn('Could not save influencer', e);
      }
      persistInfluencerInUrl(influencer);

      // Sync with cart if needed
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          var current = (cart.attributes && cart.attributes.influencer) || null;
          if (current !== influencer) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { influencer } })
            }).catch(err => console.error('Failed to update cart attribute', err));
          }
        })
        .catch(err => console.error('Error fetching cart', err));

    } else {
      // Fresh direct visit (typed domain)
      if (document.referrer === '' && performance.navigation.type === 0) {
        clearInfluencer();
      } else {
        // Restore from storage if missing in URL
        var saved = localStorage.getItem('influencer');
        if (saved) persistInfluencerInUrl(saved);
      }
    }
  }

  // Run once
  setInfluencer();

  // Re-run on navigation
  var pushState = history.pushState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    setTimeout(setInfluencer, 200);
  };
  window.addEventListener('popstate', setInfluencer);

  // Re-run on DOM mutations
  var observer = new MutationObserver(setInfluencer);
  observer.observe(document, { childList: true, subtree: true });
})();
